import icLocation from '@/assets/images/ic_location.png'

const KILOMETERS = 'km'
const METERS_IN_KM = 1000
const METERS_IN_MILE = 1609

let mapkitInstance = null

const loadMapkit = () => {
  return new Promise((resolve, reject) => {
    if (window.mapkit) {
      return resolve(window.mapkit)
    }

    const script = document.createElement('script')
    script.src = 'https://cdn.apple-mapkit.com/mk/5.45.0/mapkit.js'
    script.async = true
    script.onload = () => resolve(window.mapkit)
    script.onerror = reject

    document.head.appendChild(script)
  })
}

export default {
  install: (app, store) => {
    const getInstance = async () => {
      if (!mapkitInstance) {
        await loadMapkit()

        await new Promise(resolve => {
          window.mapkit.init({
            authorizationCallback: async (done) => {
              const res = await store.dispatch('api/getMapkitToken')
              let token = res && res.data && res.data.token
              if (process.env.NODE_ENV === 'development') {
                token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiIsImtpZCI6IjI2WlozU00yMzkifQ.eyJpc3MiOiJVRzYzVjQ4UjQ1IiwiaWF0IjoxNjU4NzYyMDE3LCJleHAiOjE2NTk5NzE2MTYwMDB9.SZ9ZEE8XpDl17X-4LYv1w24tGvEBxTJIIQbNDgdDP-ebYS5zzw_F4qOfRwInmxV_TfKgUyx6i6vODM-YWn0abQ'
              }
              done(token)
              resolve()
            },
            language: store.state.app.language,
          })
        })

        mapkitInstance = window.mapkit
      }
      return mapkitInstance
    }

    const mapkitService = {
      getInstance,

      async getCenter (latitude, longitude) {
        const mapkit = await getInstance()
        return new mapkit.Coordinate(Number(latitude), Number(longitude))
      },

      async getBusinessMarker (latitude, longitude) {
        const mapkit = await getInstance()
        const center = await this.getCenter(latitude, longitude)
        const businessPinAnnotation = new mapkit.ImageAnnotation(
          center,
          {
            url: {
              1: icLocation,
            },
          }
        )
        businessPinAnnotation.size = { width: 40, height: 61 }
        return businessPinAnnotation
      },

      async getCircleOverlay (latitude, longitude, unit, distance, customStyle) {
        const mapkit = await getInstance()
        const center = await this.getCenter(latitude, longitude)
        const style = new mapkit.Style({
          lineWidth: 2, // 2 CSS pixels
          strokeColor: '#999',
          fillColor: '#2a2d32',
          ...customStyle,
        })

        const radius = unit === KILOMETERS ? distance * METERS_IN_KM : distance * METERS_IN_MILE
        return new mapkit.CircleOverlay(center, radius, { style })
      },
    }

    app.config.globalProperties.$mapkit = mapkitService
    app.provide('mapkit', mapkitService)
  },
}
